import React, {useEffect, useState} from "react";
import ReactApexChart from "react-apexcharts";
import {NumberFormat} from "../../Helper/NumberFormat";

export const HeatpmapPreview = ({ tickers, variations, volumes,prices,currency,names, environment }) => {
    // Convertir las props en arrays
    const tickerArray = tickers.split(",");
    const variationArray = variations.split(",").map(Number);
    const volumeArray = volumes.split(",").map(Number);
    const priceArray = prices.split(",").map(Number);
    const namesArray = names.split(",");

    // Función para determinar el color basado en la variación
    const getColorForVariation = (variation) => {
        if (variation <= -5) return "#ED0029";
        if (variation > -5 && variation <= -3) return "#FF4560";
        if (variation > -3 && variation <= -1) return "#FF7043";
        if (variation > -1 && variation <= 0) return "#ffdf6c";
        if (variation > 0 && variation <= 1) return "#66BB6A";
        if (variation > 1 && variation <= 3) return "#00E396";
        if (variation > 3 && variation <= 5) return "#00897B";
        return "#004D40";
    };

    // Crear el array de datos dinámicamente
    const data = tickerArray.map((ticker, index) => ({
        x: ticker.trim(),
        y: volumeArray[index] || 0, // Volumen operado
        price: priceArray[index]?.toFixed(2) || "0.00",
        variation: variationArray[index]?.toFixed(2) || "0.00",
        name: namesArray[index],
        currency: currency,
        fillColor: getColorForVariation(variationArray[index] || 0), // Color según la variación
    }));

    const series = [
        {
            data,
        },
    ];

    const options = {
        chart: {
            type: "treemap",
            toolbar: {
                show: false,
            },
        },
        title: {
            show: false,
            align: "center",
        },
        plotOptions: {
            treemap: {
                distributed: true,
            },
        },
        dataLabels: {
            enabled: true,
            formatter: (value, { w, seriesIndex, dataPointIndex }) => {
                const { x, price, currency,name } =
                    w.config.series[seriesIndex].data[dataPointIndex];
                return `${x}`;
            },
            style: {
                fontSize: "12px",
                colors: ["#FFF"], // Color del texto
                fontWeight: "bold",
            },
            offsetY: -10, // Ajuste de la posición del texto
        },
        tooltip: {
            enabled: true,
            custom: ({ seriesIndex, dataPointIndex, w }) => {
                const { x, y, price, variation,name } =
                    w.config.series[seriesIndex].data[dataPointIndex];
                return `
                      <div style="padding: 10px; text-align: center;">
                        <strong>${x}</strong><br />
                        <strong>${name}</strong><br />
                        Size: ${NumberFormat(y,0,",",".")}<br />
                        Price: ${NumberFormat(price,2,",",".")}<br />
                        Variación: ${NumberFormat(variation,2,",",".")}%
                      </div>
                    `;
            },
        },
    };

    return (
        <div style={{ width: environment!=="PROD" ? 600 : "100vw", height: environment!=="PROD" ? 400 : "100vh" }}>
            <ReactApexChart
                options={options}
                series={series}
                type="treemap"
                width="100%"
                height="100%"
            />
        </div>
    );
};

export default HeatpmapPreview;
